import axios from 'axios';
import { API } from 'shared/api/loan';
import { baseApiUrl } from 'shared/consts';
import { EToken } from 'shared/enum';

export const refreshToken = async (): Promise<string | null> => {
  try {
    const storedRefreshToken = localStorage.getItem(EToken.REFRESH);
    if (!storedRefreshToken) return null;

    const resRefreshToken = await axios.post(`${baseApiUrl}${API.loan.authRefresh}`, { storedRefreshToken });

    const newAccessToken = resRefreshToken.data?.accessToken;
    const newRefreshToken = resRefreshToken.data?.refreshToken;

    if (newAccessToken) {
      localStorage.setItem(EToken.ACCESS, newAccessToken);
      if (newRefreshToken) {
        localStorage.setItem(EToken.REFRESH, newRefreshToken);
      }
      return newAccessToken;
    }

    return null;
  } catch (error) {
    localStorage.removeItem(EToken.ACCESS);
    localStorage.removeItem(EToken.REFRESH);
    return null;
  }
};
